import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MobileCoreRoutes } from './routes/mobile-core.routes';
import { MobileCoreTemplateComponent } from './templates/core-template/components/mobile-core-template/mobile-core-template.component';
import { HomeRoutes } from 'src/app/home/routes/home.routes';
import { MobileMyAccountRoutes } from '../my-account-a11y/routes/mobile-my-account.routes';
import { FilesRoutes } from 'src/app/files/routes/files.routes';
import { AccountRoutesEnum } from '../../../account/routes/account-routes.enum';
import { SidedrawerRoutesEnum } from '../../../sidedrawer/routes/sidedrawer-routes.enum';

const routes: Routes = [
  {
    path: MobileCoreRoutes.main,
    component: MobileCoreTemplateComponent,
    children: [
      {
        path: HomeRoutes.root,
        loadChildren: () =>
          import('../home/mobile-home.module').then(m => m.MobileHomeModule),
      },
      {
        path: MobileMyAccountRoutes.root,
        loadChildren: () =>
          import('../my-account-a11y/mobile-my-account-a11y.module').then(
            m => m.MobileMyAccountA11yModule
          ),
      },
      {
        path: FilesRoutes.shareWithSd,
        loadComponent: () =>
          import('../files/views/share-with-sd/share-with-sd.view').then(
            m => m.ShareWithSdView
          ),
      },
      {
        // NOTE: Mobile uses its own account routes file because it needs the
        // `activate-biometrics-first-time` route, which is part of the
        // first-time login flow (MobileStartFlowEffects.securityComplete$).
        // The global account.routes.ts does NOT register that route, so a
        // navigateByUrl('/core/account/activate-biometrics-first-time') would
        // silently match only `/core/account` and leave the user stranded on
        // /auth/authorize.
        path: AccountRoutesEnum.root,
        loadChildren: () =>
          import('../account/routes/mobile-account.routes'),
      },
      {
        path: SidedrawerRoutesEnum.root,
        loadChildren: () =>
          import('../../../sidedrawer/routes/sidedrawer.routes'),
      },
    ],
  },
  {
    path: MobileCoreRoutes.error + '/:dictionaryFails',
    loadChildren: () =>
      import('../../../core/views/sd-general-error-a11y/sd-general-error-a11y.module').then(
        m => m.SdGeneralErrorA11yModule
      ),
  },
  {
    path: MobileCoreRoutes.error,
    loadChildren: () =>
      import('../../../core/views/sd-general-error-a11y/sd-general-error-a11y.module').then(
        m => m.SdGeneralErrorA11yModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MobileCoreRoutingModule {}
